import React, { useEffect, useState } from 'react';
import { ILegalRequirement } from '../../Interfaces/ILegalRequirement';
import { IDocument } from '../../Interfaces/IDocument';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Tooltip,
} from '@mui/material';
import { ContactPage, InsertDriveFile } from '@mui/icons-material';
import { DocumentOverview } from '../../Document/DocumentOverview';
import { IDocumentDownloaded } from '../../Interfaces/IDocumentDownloaded';

interface IProps {
  legalRequirementObject: ILegalRequirement;
  setLegalRequirementObject: Function;
  isNotDisabled: boolean;
  downloadedArray?: IDocumentDownloaded[];
}

export const LegalRequirementDocuments: React.FC<IProps> = ({
  legalRequirementObject,
  setLegalRequirementObject,
  isNotDisabled,
  downloadedArray,
}) => {
  const [documentArrayClient, setDocumentArrayClient] = useState<IDocument[]>(
    legalRequirementObject.DocumentArrayClient === undefined
      ? []
      : legalRequirementObject.DocumentArrayClient
  );

  const [documentArrayEmployees, setDocumentArrayEmployees] = useState<
    IDocument[]
  >([]);

  const isSendEmailPossible =
    legalRequirementObject.sendMail === true ||
    legalRequirementObject.isInterneLegalRequirement === true;

  useEffect(() => {
    const updatedArray = legalRequirementObject.DocumentArrayEmployees
      ? legalRequirementObject.DocumentArrayEmployees.map(doc => ({
          ...doc,
          perEmail: isSendEmailPossible ? doc.perEmail : false,
        }))
      : [];

    setDocumentArrayEmployees(updatedArray);
  }, [isSendEmailPossible]);

  const [isOpenClient, setIsOpenClient] = useState(false);
  const [isOpenEmployees, setIsOpenEmployees] = useState(false);

  const hanldeOpenEmployees = () => {
    setDocumentArrayEmployees(
      legalRequirementObject.DocumentArrayEmployees === undefined
        ? []
        : legalRequirementObject.DocumentArrayEmployees
    );
    setIsOpenEmployees(true);
  };

  const handleSave = () => {
    setLegalRequirementObject({
      ...legalRequirementObject,
      DocumentArrayEmployees: documentArrayEmployees,
      DocumentArrayClient: documentArrayClient,
    } as ILegalRequirement);
    setIsOpenEmployees(false);
    setIsOpenClient(false);
  };

  return (
    <>
      <Dialog
        open={isOpenClient}
        onClose={() => setIsOpenClient(false)}
        maxWidth='lg'
        fullWidth
      >
        <DialogContent>
          <DocumentOverview
            key={`DocumentOverview-client`}
            documentArray={documentArrayClient}
            setDocumentArray={setDocumentArrayClient}
            allowRemove={true}
            allowUpload={false}
            title='Daten vom Mandanten'
            downloadedArray={downloadedArray}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setIsOpenClient(false)}>
            Abbruch
          </Button>
          <Button variant='contained' onClick={handleSave}>
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isOpenEmployees}
        onClose={() => setIsOpenEmployees(false)}
        maxWidth='lg'
        fullWidth
      >
        <DialogContent>
          <DocumentOverview
            key={`DocumentOverview-employees`}
            documentArray={documentArrayEmployees}
            setDocumentArray={setDocumentArrayEmployees}
            allowRemove={true}
            allowUpload={true}
            title='Für den Mandanten bereitgestellte Daten'
            downloadedArray={downloadedArray}
            isStandarddocument={true}
            isSendEmailPossible={isSendEmailPossible}
          />
        </DialogContent>
        <DialogActions>
          <Button variant='outlined' onClick={() => setIsOpenEmployees(false)}>
            Abbruch
          </Button>
          <Button variant='contained' onClick={handleSave}>
            Übernehmen
          </Button>
        </DialogActions>
      </Dialog>

      {documentArrayClient.length > 0 &&
        legalRequirementObject.canUploadFilesClient === true && (
          <Tooltip title={'Runterladen von Mandantendaten'}>
            <IconButton
              onClick={() => {
                setIsOpenClient(true);
              }}
              disabled={!isNotDisabled}
            >
              <ContactPage />
            </IconButton>
          </Tooltip>
        )}
      {legalRequirementObject.canUploadFilesEmployees === true && (
        <Tooltip title={'Daten für Mandanten hochladen'}>
          <IconButton onClick={hanldeOpenEmployees} disabled={!isNotDisabled}>
            <InsertDriveFile />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
};
